module.exports = __webpack_public_path__ + "static/media/fanny_med_2.1c92139b.jpg";